
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 19.242c-4.614 0-7.848-2.154-9.964-4.36a17.544 17.544 0 01-2.33-3.043 14.712 14.712 0 01-.68-1.26 4.146 4.146 0 01-.029-.065l-.006-.013-.996.398-.995.398.005.013a4.314 4.314 0 00.054.12c.037.078.09.19.16.328.139.278.347.668.628 1.134a19.638 19.638 0 002.61 3.41C5.843 18.787 9.611 21.327 15 21.327v-2.086zm14.005-8.343l-.996-.399-.006.014a8.873 8.873 0 01-.158.332c-.119.235-.302.578-.552.993a17.538 17.538 0 01-2.329 3.043c-2.116 2.206-5.35 4.36-9.964 4.36v2.086c5.39 0 9.157-2.54 11.543-5.027a19.632 19.632 0 002.61-3.41 16.813 16.813 0 00.788-1.461 6.43 6.43 0 00.053-.12l.004-.009c.002-.004.002-.005-.993-.402zm-12.928 14.6v-5.214h-2.154v5.214h2.154zM2.834 22.065l4.31-4.172L5.62 16.42l-4.31 4.17 1.524 1.475zm20.022-4.172l4.31 4.172 1.523-1.475-4.31-4.171-1.523 1.474z"}})])
          )
        }
      }
    